import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { getMarginOptions } from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import {
  getListStylePositionOptions,
  getListStyleTypeOptions,
} from "@circle-react-shared/BuilderUI/utils/listStyleTextHelpers";
import {
  getHeightOptions,
  getWidthOptions,
} from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getFontStyleOptions,
  getFontWeightOptions,
  getLineHeightOptions,
  getTextAlignOptions,
  getTextDecorationOptions,
  getTextTransformOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const bulletStyles: Record<string, StyleValue> = {
  backgroundColor: getBackgroundColorOptions({
    defaultValue: "var(--theme-website-color-6)",
  }),
  width: getWidthOptions({
    defaultValue: "16px",
  }),
  height: getHeightOptions({
    defaultValue: "16px",
  }),
  margin: getMarginOptions({
    defaultValue: {
      marginBottom: "3",
      marginRight: "3",
      marginLeft: "3",
      marginTop: "3",
    },
  }),
};

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ul",
  props: {
    items: {
      prop: "other",
      type: "list",
      value: [
        {
          id: uuidv4(),
          value: "Item 1",
          bullet: {
            emoji: "",
            signed_id: "",
            placeholder: "",
          },
        },
        {
          id: uuidv4(),
          value: "Item 2",
          bullet: {
            emoji: "",
            signed_id: "",
            placeholder: "",
          },
        },
        {
          id: uuidv4(),
          value: "Item 3",
          bullet: {
            emoji: "",
            signed_id: "",
            placeholder: "",
          },
        },
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        color: getColorOptions(defaultStyles.color),
        fontStyle: getFontStyleOptions(defaultStyles.fontStyle),
        fontWeight: getFontWeightOptions(defaultStyles.fontWeight),
        fontSize: getFontSizeOptions(defaultStyles.fontSize),
        lineHeight: getLineHeightOptions(defaultStyles.lineHeight),
        textAlign: getTextAlignOptions(defaultStyles.textAlign),
        textDecoration: getTextDecorationOptions(defaultStyles.textDecoration),
        listStyleType: getListStyleTypeOptions(defaultStyles.listStyleType),
        listStylePosition: getListStylePositionOptions(
          defaultStyles.listStylePosition,
        ),
        textTransform: getTextTransformOptions(defaultStyles.textTransform),
      },
    },
  },
};
